import { apiWrapper } from "@/services/api";
import store from "@/store";

export const validBooks = async (books) => {
  try {
    let apiParams = [];

    books.forEach(function (bookEach) {
      apiParams.push({ id: bookEach.id });
    });
    console.log("validBooks :>> ", apiParams);

    const resp = await apiWrapper("POST", `valid_books`, apiParams);
    store.commit("ticketing/setBook", resp.data[0]);
    return resp.data;
  } catch (err) {
    console.log("ERROR!! validBooks()");
    throw err;
  }
};
